import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { getEmpresa } from '../../../services/empresaService';
import { montarDuplicata } from './gerarDuplicata';

async function GerarCarne(dadosCarnes = [], dadosDuplicata = null) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const empresa = await getEmpresa();

  let duplicataFormatada = null;

if (dadosDuplicata) {

  duplicataFormatada = {
    empresa: empresa.RAZAO_SOCIAL,
    endereco: empresa.ENDERECO,
    cidade: `${empresa.BAIRRO} - ${empresa.CIDADE} - ${empresa.UF}`,
    cep: empresa.CEP,
    numeroControle: dadosDuplicata.NOSSO_NUMERO,
    cidadeEmissao: `${empresa.CIDADE} - ${empresa.UF}`,
    dataEmissao: dadosDuplicata.DATA_EMISSAO,
    nf: dadosDuplicata.DOCUMENTO,
    valor: dadosDuplicata.TOTAL_PAGAR,
    ordem: dadosDuplicata.DOCUMENTO,
    vencimento: dadosDuplicata.DATA_VENC,
    juros: "",
    multa: "",
    desconto: "",
    descricao: "",
    sacadoCodigo: dadosDuplicata.RESPONSAVEL,
    sacadoNome: dadosDuplicata.RAZAO,
    enderecoSacado: dadosDuplicata.ENDERECO,
    complemento: "",
    cepMunicipio: `${dadosDuplicata.CEP} - ${dadosDuplicata.CIDADE}`,
    cpfCnpj: dadosDuplicata.CNPJ,
    representante: "",
    valorExtenso: dadosDuplicata.VALOR_EXTENSO
  };

}

  const carnes = Array.isArray(dadosCarnes) && dadosCarnes.length
    ? dadosCarnes
    : [
        {
          empresa: "PERNAMBUCO COMERCIAL DE COSMETICOS E",
          cnpj: "10488149000115",
          titulo: "001136",
          documento: "1136",
          nossoNumero: "1136",
          vencimento: "23/03/2026",
          emissao: "23/02/2026",
          valor: 2.00,
          desconto: 0.00,
          juros: 0.00,
          multa: 0.00,
          sacadoCodigo: "65",
          sacadoNome: "CAROLINE",
          linhaDigitavel: "09669513448"
        },
        

     
      ];

  function montarVia(titulo, tipoVia) {

    const valorCobrado =
      Number(titulo.valor || 0) -
      Number(titulo.desconto || 0) +
      Number(titulo.juros || 0) +
      Number(titulo.multa || 0);

    return {
      width: '50%',
      table: {
        widths: ['40%', '60%'],
        body: [

          [{ text: tipoVia, bold: true, colSpan: 2, margin: [4, 2] }, {}],

          [
            {
              text: `${empresa.RAZAO_SOCIAL}\n${empresa.CGC}`,
              colSpan: 2,
              alignment: 'center',
              bold: true,
              margin: [0, 4]
            },
            {}
          ],

          ['Nº Título', titulo.titulo],
          ['Data Vencimento', titulo.vencimento],

          ['(=) Valor', `R$ ${Number(titulo.valor).toFixed(2)}`],
          ['(-) Desconto', ``],
          ['(+) Juros', ``],
          ['(+) Multa', ``],
          ['(=) Valor Cobrado', ``],

          ['Nº Documento', titulo.documento],
          ['Nosso Número', titulo.nossoNumero],
          ['Data Emissão', titulo.emissao],

          [
            {
              text: titulo.linhaDigitavel,
              colSpan: 2,
              fontSize: 7,
              margin: [4, 3]
            },
            {}
          ],

          ['Sacado', `${titulo.sacadoCodigo} - ${titulo.sacadoNome}`],

          [
            {
              text: titulo.linhaDigitavel,
              colSpan: 2,
              alignment: 'center',
              bold: true,
              margin: [0, 6]
            },
            {}
          ]
        ]
      },
      layout: {
        hLineWidth: () => 0.7,
        vLineWidth: () => 0.7
      },
      margin: [3, 3]
    };
  }

  function gerarConteudo(lista) {

    const content = [];

    lista.forEach((titulo, index) => {

      content.push({
        columns: [
          montarVia(titulo, 'VIA SACADO'),
          montarVia(titulo, 'VIA CEDENTE')
        ],
        columnGap: 10,
        margin: [0, 5]
      });

      // 🔥 Quebra EXATA a cada 2 carnês
      if ((index + 1) % 2 === 0 && index !== lista.length - 1) {
        content.push({ text: '', pageBreak: 'after' });
      }

    });

    return content;
  }

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [10, 10, 10, 10], // 🔥 margem mínima

    content: [

  ...gerarConteudo(carnes),

  ...(duplicataFormatada
    ? [
        { text: "", pageBreak: "before" },
        montarDuplicata(duplicataFormatada)
      ]
    : [])

],

    defaultStyle: {
      fontSize: 8
    }
  };

  pdfMake.createPdf(docDefinition).open();
}

export default GerarCarne;